module.exports = __webpack_public_path__ + "f205d217e019ca9f0a32e646489554f6.MP3";